import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import '../src/assets/css/global.css' /*引入公共样式*/
// 导入组件相关样式
Vue.prototype.$axios = axios
import Cookies from 'js-cookie'
import '@/assets/css/animate.min.css'
import wow from 'wowjs'
Vue.prototype.$wow = wow

import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker)

var token = Cookies.get('userinfo')
if (token && token != 'undefined') {
	// window.console.log(token)
	token = JSON.parse(token).token
	axios.interceptors.request.use(
		config => {
			config.headers['token'] = token
			return config
		},
		err => {
			return Promise.reject(err)
		})
}

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)


import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

//直播复制功能
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'

Vue.use(VueDirectiveImagePreviewer, {
	zIndex: 9999, //层级显示
	previewSize: 2, //三倍图
	animate: {
		duration: 300,
		delay: 100
	},
})

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

import env from '@/api/env.config.js'
Vue.prototype.prod = env.baseUrl.prod

// 配置 Vue 插件
Vue.use(ElementUI);

import router from './router'

router.afterEach(() => {
	window.scrollTo(0, 0);
	document.body.scrollTop = 0
	document.documentElement.scrollTop = 0
	window.pageYOffset = 0
});

new Vue({
	router, //子组件可以用this.$router来访问路由
	render: h => h(App)
}).$mount('#app')



